import request from '@/utils/request'

/** 退款列表（状态：1待审核/2已完成/3未通过） */
export function refundList(data) {
  return request.post('/refund/index', data)
}

/** 申请退款：POST order_id amount voucher transaction_id */
export function refundAdd(data) {
  return request.post('/refund/add', data)
}

/** 审核退款：POST id action(pass/refuse) perform_date audit_remark */
export function refundAudit(id, action, performDate, remark) {
  return request.post('/refund/audit', { id, action, perform_date: performDate, audit_remark: remark })
}
